<template>
  <div>
    <vue-toastr ref="mytoast"></vue-toastr>
    <draggable class="row" tag="div" v-model="filters" group="filters" @start="drag=true" @end="updateFilterList"
               handle=".filter-handler" v-for="filterArray in lodash.chunk(filters, 6)">
      <div class="col-md-2" v-for="filter in filterArray">
        <div class="panel panel-success">
          <div class="panel-heading">
            <strong><i class="fa fa-bars filter-handler" style="cursor:grab" aria-hidden="true"></i> {{
                filter.title
              }}</strong>
          </div>
          <div class="panel-body">
            <table class="table table-hover">
              <draggable group="options" tag="tbody" v-model="filter.options" @start="drag=true"
                         @end="updateOptionList(filter.options)" handle=".option-handler">
                <tr v-for="option in filter.options">
                  <td><i class="fa fa-bars option-handler" style="cursor:grab;" aria-hidden="true"></i>
                    {{ option.option }}
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import VueToastr from "vue-toastr";
import _ from "lodash"

export default {
  name: 'BmFilterReorder',
  props: ['filters'],
  components: {draggable, VueToastr},
  data() {
    return {
      lodash: _
    }
  },
  methods: {
    updateFilterList() {
      axios.post('/api/fmu/filters/reorder', {
        filters: this.filters
      }).then(() => {
        this.$refs.mytoast.s("Neue Sortierung gespeichert", "Erfolgreich");
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    },
    updateOptionList(options) {
      axios.post('/api/fmu/options/reorder', {
        options: options
      }).then(() => {
        this.$refs.mytoast.s("Neue Sortierung gespeichert", "Erfolgreich");
        this.$forceUpdate();
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    }
  }
}
</script>

<style scoped>
</style>
